<template>
  <CRow>
    <CCol col="12">
      <loader v-show="loading" />
      <CCard>
        <CCardHeader> Add New FAQ </CCardHeader>
        <CCardBody>
          <div class="form-group">
            <label>Question</label>
            <input type="text" class="form-control" v-model="data.question" />
          </div>
          <div class="form-group">
            <label>Answer</label>
            <wysiwyg v-model="data.answer" />
          </div>
          <div class="form-group">
            <label>List Number</label>
            <input type="number" class="form-control" v-model="data.sort" />
          </div>
        </CCardBody>
        <CCardFooter>
          <btn-save-update
            :data="data"
            @back="doBack"
            @save="doSave"
            @update="doUpdate"
          />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import BtnSaveUpdate from "../../components/BtnSaveUpdate";
import Loader from "../../components/Loader.vue";
import { showErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    BtnSaveUpdate,
    Loader,
  },
  data() {
    return {
      data: {},
      loading: true,
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.id && params.id != "new") {
      this.get(params.id);
    } else {
      this.loading = false;
    }
  },
  methods: {
    doBack() {
      this.$router.push({ path: "/faq/list" });
    },
    doSave() {
      this.loading = true;
      this.data.sort = parseInt(this.data.sort);
      HTTPAUTH.post("/api/admin/faq", this.data)
        .then((res) => {
          this.data = res.data.data;
          this.doBack();
          this.loading = false;
        })
        .catch((eres) => {
          showErrorMessage(eres);
          this.loading = false;
        });
    },
    doUpdate() {
      this.loading = true;
      HTTPAUTH.put("/api/admin/faq/" + this.data.id, this.data)
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          showErrorMessage(eres);
          this.loading = false;
        });
    },
    get(id) {
      HTTPAUTH.get("/api/admin/faq/" + id)
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          showErrorMessage(eres);
          this.loading = false;
        });
    },
  },
};
</script>